import { isBrowser } from '../utils/dom.js';

type DefaultWindowGlobal = {
  apiBase: string;
  hostUrl: string;
  routeBaseName: string;
};

export const useGlobal = <T = DefaultWindowGlobal>() => {
  return (isBrowser ? (window as any).GLOBAL : {}) as T;
};
